var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "chat-wrapper"
    }
  }, [_c('div', {
    staticClass: "chat-block-broker"
  }, [_c('div', {
    staticClass: "chat-broker-header"
  }, [_c('div', {
    staticClass: "header-chat-broker"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "close",
      "size": 24
    }
  })], 1), _c('client-chat-share-handler', {
    attrs: {
      "client-object": _vm.getClientShareInfo()
    }
  })], 1), _c('div', {
    staticClass: "client-name-block"
  }, [_c('img', {
    staticClass: "image-10",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png",
      "loading": "lazy",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "div-block-28"
  }, [_c('user-manager-handler', {
    attrs: {
      "rules": ['single'],
      "client-info": _vm.client,
      "client": "",
      "clients": ""
    }
  })], 1)])]), _vm.clientChatInitialized ? _c('div', {
    ref: "chat-window",
    staticClass: "chat-panel-broker broker flex-column-reverse",
    on: {
      "scroll": _vm.checkForNextPage
    }
  }, _vm._l(_vm.messages, function (message, key) {
    return _c('div', {
      key: key,
      "class": [message.sender === _vm.client.id ? 'question-broker-chat' : 'question-block-broker']
    }, [_c('div', {
      "class": [message.sender === _vm.client.id ? 'message-answer' : 'message-question']
    }, [_vm.isUrl(message.content) ? _c('div', {
      "class": [message.sender === _vm.client.id ? 'text-message-left' : 'text-message-right-2']
    }, [_vm._v(" " + _vm._s(message.content) + " ")]) : _c('div', {
      staticClass: "text-message-right-2",
      domProps: {
        "innerHTML": _vm._s(_vm.urlify(message.content))
      }
    }), message.attachment ? _c('div', {
      staticClass: "file-to-download"
    }, [_c('a', {
      staticClass: "download-link-2",
      "class": [message.sender === _vm.client.id ? 'white--text' : 'bl-color'],
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "target": "_blank",
        "href": message.attachment,
        "download": message.attachment_filename
      }
    }, [_vm._v(_vm._s(message.attachment_filename))]), message.sender !== _vm.client.id ? _c('svg', {
      attrs: {
        "width": "25",
        "height": "25",
        "viewBox": "0 0 15 14",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M10.2808 11.667H3.92889C3.75039 11.667 3.60514 11.5363 3.60514 11.3753V2.62533C3.60514 2.46433 3.75039 2.33366 3.92889 2.33366H6.52181V4.75449C6.52181 5.67149 7.23173 6.41699 8.10498 6.41699H10.6051V11.3753C10.6051 11.5363 10.4593 11.667 10.2808 11.667ZM10.4004 5.25033H8.10498C7.87514 5.25033 7.68848 5.02808 7.68848 4.75449V2.33366H7.75381L10.4004 5.25033ZM11.6201 4.85833L8.44448 1.35833C8.33423 1.23641 8.17731 1.16699 8.01223 1.16699H3.92889C3.10698 1.16699 2.43848 1.82149 2.43848 2.62533V11.3753C2.43848 12.1792 3.10698 12.8337 3.92889 12.8337H10.2808C11.1027 12.8337 11.7718 12.1792 11.7718 11.3753V5.25033C11.7718 5.10508 11.7176 4.96566 11.6201 4.85833Z",
        "fill": "$primary"
      }
    }), _c('mask', {
      staticStyle: {
        "mask-type": "alpha"
      },
      attrs: {
        "id": "mask0_1400_480",
        "maskUnits": "userSpaceOnUse",
        "x": "2",
        "y": "1",
        "width": "10",
        "height": "12"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M10.2808 11.667H3.92889C3.75039 11.667 3.60514 11.5363 3.60514 11.3753V2.62533C3.60514 2.46433 3.75039 2.33366 3.92889 2.33366H6.52181V4.75449C6.52181 5.67149 7.23173 6.41699 8.10498 6.41699H10.6051V11.3753C10.6051 11.5363 10.4593 11.667 10.2808 11.667ZM10.4004 5.25033H8.10498C7.87514 5.25033 7.68848 5.02808 7.68848 4.75449V2.33366H7.75381L10.4004 5.25033ZM11.6201 4.85833L8.44448 1.35833C8.33423 1.23641 8.17731 1.16699 8.01223 1.16699H3.92889C3.10698 1.16699 2.43848 1.82149 2.43848 2.62533V11.3753C2.43848 12.1792 3.10698 12.8337 3.92889 12.8337H10.2808C11.1027 12.8337 11.7718 12.1792 11.7718 11.3753V5.25033C11.7718 5.10508 11.7176 4.96566 11.6201 4.85833Z",
        "fill": "white"
      }
    })]), _c('g', {
      attrs: {
        "mask": "url(#mask0_1400_480)"
      }
    }, [_c('rect', {
      attrs: {
        "x": "0.104492",
        "width": "14",
        "height": "14",
        "fill": "#0019D9"
      }
    })])]) : _c('svg', {
      attrs: {
        "width": "25",
        "height": "25",
        "viewBox": "0 0 15 14",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M10.2808 11.667H3.92889C3.75039 11.667 3.60514 11.5363 3.60514 11.3753V2.62533C3.60514 2.46433 3.75039 2.33366 3.92889 2.33366H6.52181V4.75449C6.52181 5.67149 7.23173 6.41699 8.10498 6.41699H10.6051V11.3753C10.6051 11.5363 10.4593 11.667 10.2808 11.667ZM10.4004 5.25033H8.10498C7.87514 5.25033 7.68848 5.02808 7.68848 4.75449V2.33366H7.75381L10.4004 5.25033ZM11.6201 4.85833L8.44448 1.35833C8.33423 1.23641 8.17731 1.16699 8.01223 1.16699H3.92889C3.10698 1.16699 2.43848 1.82149 2.43848 2.62533V11.3753C2.43848 12.1792 3.10698 12.8337 3.92889 12.8337H10.2808C11.1027 12.8337 11.7718 12.1792 11.7718 11.3753V5.25033C11.7718 5.10508 11.7176 4.96566 11.6201 4.85833Z",
        "fill": "#0019D9"
      }
    }), _c('mask', {
      staticStyle: {
        "mask-type": "alpha"
      },
      attrs: {
        "id": "mask0_1400_480",
        "maskUnits": "userSpaceOnUse",
        "x": "2",
        "y": "1",
        "width": "10",
        "height": "12"
      }
    }, [_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M10.2808 11.667H3.92889C3.75039 11.667 3.60514 11.5363 3.60514 11.3753V2.62533C3.60514 2.46433 3.75039 2.33366 3.92889 2.33366H6.52181V4.75449C6.52181 5.67149 7.23173 6.41699 8.10498 6.41699H10.6051V11.3753C10.6051 11.5363 10.4593 11.667 10.2808 11.667ZM10.4004 5.25033H8.10498C7.87514 5.25033 7.68848 5.02808 7.68848 4.75449V2.33366H7.75381L10.4004 5.25033ZM11.6201 4.85833L8.44448 1.35833C8.33423 1.23641 8.17731 1.16699 8.01223 1.16699H3.92889C3.10698 1.16699 2.43848 1.82149 2.43848 2.62533V11.3753C2.43848 12.1792 3.10698 12.8337 3.92889 12.8337H10.2808C11.1027 12.8337 11.7718 12.1792 11.7718 11.3753V5.25033C11.7718 5.10508 11.7176 4.96566 11.6201 4.85833Z",
        "fill": "white"
      }
    })]), _c('g', {
      attrs: {
        "mask": "url(#mask0_1400_480)"
      }
    }, [_c('rect', {
      attrs: {
        "x": "0.104492",
        "width": "14",
        "height": "14",
        "fill": "#fff"
      }
    })])])]) : _vm._e()])]);
  }), 0) : _c('div', {
    staticClass: "d-flex justify-content-center align-items-center",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner",
    attrs: {
      "indeterminate": ""
    }
  })], 1), _vm.fileName ? _c('div', {
    staticClass: "filename"
  }, [_c('div', {
    staticClass: "pop-300 white--text"
  }, [_c('img', {
    staticClass: "pb-1",
    attrs: {
      "src": require("@/images/CloudChat.svg"),
      "alt": ""
    }
  }), _c('span', {
    staticClass: "pl-2"
  }, [_vm._v(" " + _vm._s(_vm.fileName) + " ")])]), _c('div', {
    staticClass: "red--text pop-400 pointer",
    on: {
      "click": function click($event) {
        return _vm.removeFile();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/images/RemoveFileChat.svg"),
      "alt": ""
    }
  })])]) : _vm._e(), _c('div', {
    staticClass: "chat-input-grid"
  }, [_c('div', {
    staticClass: "form-block w-form"
  }, [_c('form', {
    attrs: {
      "name": "chat-message"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.messageValue,
      expression: "messageValue"
    }],
    staticClass: "message-text-2 w-input",
    "class": {
      'message-is-missing': _vm.messageMissing
    },
    attrs: {
      "maxlength": "256",
      "type": "text",
      "placeholder": "Napíšte odpoveď .."
    },
    domProps: {
      "value": _vm.messageValue
    },
    on: {
      "click": _vm.setSeen,
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.sendMessage.apply(null, arguments);
      },
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.messageValue = $event.target.value;
      }
    }
  }), _c('input', {
    staticClass: "d-none",
    attrs: {
      "type": "submit",
      "id": "submit-form"
    }
  })])]), _c('div', {
    staticClass: "chat-ctas"
  }, [_c('quick-response-chat-handler'), _c('div', {
    staticClass: "image-upload-btn"
  }, [_vm._m(0), _c('input', {
    attrs: {
      "id": "file-upload",
      "type": "file"
    },
    on: {
      "change": _vm.handleFiles
    }
  })]), _c('span', {
    staticClass: "send-button pointer",
    on: {
      "click": _vm.sendMessage
    }
  }, [_c('img', {
    staticClass: "nav-link-icon small white",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f2c_icons8-sent.svg"
    }
  })])], 1)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticStyle: {
      "margin-bottom": "0 !important"
    },
    attrs: {
      "for": "file-upload"
    }
  }, [_c('img', {
    staticClass: "nav-link-icon small filter-primary",
    attrs: {
      "src": "https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1e_icons8-upload-to-the-cloud.svg"
    }
  })]);

}]

export { render, staticRenderFns }